import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import moment from 'moment';
import { SortableHandle, SortableElement } from 'react-sortable-hoc';
import { Link } from 'react-router';
import { Toggle } from '@zola/zola-ui';
import homeImg from '../../../../../../assets/images/website/manage-redesign/wedding-rings.svg';
import travelImg from '../../../../../../assets/images/website/manage-redesign/travel.svg';
import registryImg from '../../../../../../assets/images/website/manage-redesign/registry.svg';
import eventImg from '../../../../../../assets/images/website/manage-redesign/schedule.svg';
import weddingPartyImg from '../../../../../../assets/images/website/manage-redesign/wedding-party.svg';
import photoImg from '../../../../../../assets/images/website/manage-redesign/photos.svg';
import poiImg from '../../../../../../assets/images/website/manage-redesign/things-to-do.svg';
import rsvpImg from '../../../../../../assets/images/website/manage-redesign/rsvp.svg';
import faqImg from '../../../../../../assets/images/website/manage-redesign/faq.svg';
import lockIcon from '../../../../../../assets/images/website/manage-redesign/lock-icon.svg';
import './PageListItem.styles.less';

const iconListMap = {
  home: homeImg,
  travel: travelImg,
  registry: registryImg,
  event: eventImg,
  wedding_party: weddingPartyImg,
  photo: photoImg,
  poi: poiImg,
  rsvp: rsvpImg,
  faq: faqImg
};

const DragHandle = SortableHandle(({ disabled, tooltip }) => (
  <div className={cx({ 'page-list-item__reorder--disabled': disabled })} title="Drag to reorder" data-tooltip={tooltip}>
    <i className="zolaicon zolaicon-bullets-none" />
  </div>
));


const PageListItem = SortableElement(({ registry, onToggle, page, hasRegistry, onRegistryPublish, registryPublished, handleOpenRegistryModal }) => {
  const isHomePage = page.type === 'HOME';
  const isRegistryPage = page.type === 'REGISTRY';
  const entitiesSummary = page && page.entities_summary;
  const entityCount = entitiesSummary && entitiesSummary.entity_count;
  const entityCountMessage = entityCount ? `${entityCount} ${page.menu_title} Added` : 'Not Started';
  const updatedAt = entitiesSummary && entitiesSummary.updated_at;
  const lastTimeEdited = updatedAt ? `Edited ${moment(updatedAt).fromNow()}` : '';
  const registryNotStarted = isRegistryPage && !hasRegistry;

  const addRegistryBytton = (
    <div className="mpr-page-list-item__registry">
      <div className="mpr-page-list-item__registry__btn-container">
        <a
          href="/onboard/new"
          className="mpr-page-list-item__registry__btn"
        >
          <span>Start Zola Registry</span>
        </a>
      </div>
      <div className="mpr-page-list-item__registry__link-container">
        <a
          onClick={(e) => {
            e.preventDefault();
            handleOpenRegistryModal();
          }}
          className="mpr-page-list-item__registry__link"
          href="#"
        >
          Link Another Registry
        </a>
      </div>
    </div>
  );

  const getRegistryStatus = () => {
    if (registryNotStarted) {
      return addRegistryBytton;
    }

    if (!registryPublished) {
      return (
        <React.Fragment>
          <a role="button" onClick={() => onRegistryPublish(!registry.is_public)} className="mpr-page-list-item__publish-registry">
            Make Visible to Guests
          </a>
          <div className="with-tooltip mpr-page-list-item__publish-registry-tooltip" data-tooltip="Your registry must be visible for guests to shop.">
            <i className="zolaicon zolaicon-info mpr-page-list-item__publish-registry__icon" />
          </div>
        </React.Fragment>
      );
    }

    if (!entityCount && registryPublished) {
      return 'Registry Published';
    }

    return entityCountMessage;
  };


  const titleEl = (
    <Link
      className="mpr-page-list-item__title"
      to={`/wedding/manage/website/pages/${page.type.toLowerCase()}`}
    >
      {page.menu_title}
    </Link>
  );

  const switchEl = (
    <div className="mpr-page-list-item__switch">
      {isHomePage ? <span className="mpr-page-list-item__enabled-message">Must Be Enabled</span> : <Toggle input={{ value: !page.hidden, onChange: onToggle }} withIcons />}
    </div>
  );

  return (
    <li className={cx('mpr-page-list-item', { 'mpr-page-list-item--inactive-page': page.hidden })}>
      <div className="mpr-page-list-item__content">
        <div className="mpr-page-list-item__reorder-handle">
          {isHomePage ? <img draggable={false} src={lockIcon} alt="Lock Icon" /> : <DragHandle disabled={isHomePage} tooltip="Drag to reorder" />}
        </div>
        <img
          className={cx('mpr-page-list-item__img', { 'mpr-page-list-item__img--isRegistry-mobile': registryNotStarted })}
          src={iconListMap[page.type.toLowerCase()]}
          alt={`${page.type}`}
        />
        <div className="mpr-page-list-item__group">
          <div className="mpr-page-list-item__group--mobile">
            {titleEl}
            {switchEl}
          </div>
          <div className="mpr-page-list-item__group-title--desktop">
            {titleEl}
          </div>
          <span className="mpr-page-list-item__subtitle--mobile">
            {isRegistryPage ? getRegistryStatus() : entityCountMessage}
          </span>
          <span className="mpr-page-list-item__subtitle--desktop">{lastTimeEdited}</span>
        </div>

        <div className="mpr-page-list-item__group--desktop">
          {switchEl}
        </div>

        <div className="mpr-page-list-item__status">
          {isRegistryPage ? getRegistryStatus() : entityCountMessage}
        </div>
      </div>
    </li>
  );
});

PageListItem.propTypes = {
  onToggle: PropTypes.func,
  page: PropTypes.shape({}),
  hasRegistry: PropTypes.bool,
  registryPublished: PropTypes.bool,
  onRegistryPublish: PropTypes.func,
  registry: PropTypes.shape({}),
  handleOpenRegistryModal: PropTypes.func.isRequired
};

export default PageListItem;



// WEBPACK FOOTER //
// ./src/components/manage/website/ManagePagesRedesign/Pages/PageListItem/PageListItem.jsx